// extracted by mini-css-extract-plugin
module.exports = {"singlePill":"cBnNcSOL","pillTextWrapper":"_28SvV-Tg","pillType":"_3DnyIdpu","capitalize":"jtnHXhnV","pillText":"_2ol2w933"};